<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-10">1.</p>
<p class="BT1stPara"><span class="CharOverride-5">In the dark smelly place beneath the sink. Behind the drainpipes. She has made herself small enough to hide here.</span></p>
<p class="BT"><span class="CharOverride-5">Strands of a broken spider’s web sticking to her skin. Her eyes wet with tears. Hunching her back like a little monkey. Arms closed tight around her knees raised against her small flat chest.</span></p>
<p class="BT"><span class="CharOverride-5">She is just a little girl, small enough to save herself. Small enough to fit into the spider’s web. Smart enough to know that she must not cry.</span></p>
<p class="BT"><span class="CharOverride-5">Must not breathe. So that no one can hear.</span></p>
<p class="BT"><span class="CharOverride-5">So that </span>he <span class="CharOverride-5">can’t hear.</span></p>
<p class="BT"><span class="CharOverride-5">The door to the hiding place is opened, she sees a man’s feet, legs. She sees, does not see, the glisten of something dark and wet on the trouser legs. She hears, does not hear, his quick, hot panting. With a whoop of wild laughter he stoops to peer inside. He has discovered her. His face is a blur of tears. His mouth moves and is talking to her, but she hears no words. But then the door is shut again and she is alone.</span></p>
<p class="BT"><span class="CharOverride-5">In this way, it is determined. In the spider’s web she is allowed to live.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-9.vue?7d4a7b40